/**
 * @module middleware/SharedState
 * Middleware to apply common state to each action
 */
import { getCurrentListenerIdFromState } from '../lib/ListenerUtils';

/**
 * Applies bits of state to each action passing through
 *
 * @param  {object} store - redux
 * @param  {object} next - dispatch function of next middleware in the chain
 * @param  {object} action - the current action
 * @param store.getState
 * @returns {object} The action to pass to the store
 */
export default ({ getState }) =>
  next =>
  action => {
    const state = getState();
    action.sharedState = {
      listenerId: getCurrentListenerIdFromState(state),
    };
    return next(action);
  };
